import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-why-choose-us',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './why-choose-us.html',
  styleUrl: './why-choose-us.scss'
})
export class WhyChooseUs {
  s3BaseUrl = environment.s3BaseUrl;
  benefits = [
    {
      icon: `${environment.s3BaseUrl}/icons/features/location.png`,
      title: 'Buena ubicación',
      description: 'A una hora y 15 minutos de la capital ubicarás nuestro Park Resort La Joya'
    },
    {
      icon: `${environment.s3BaseUrl}/icons/features/building.png`,
      title: 'Instalaciones de lujo',
      description: 'Diseñada para optimizar tu estancia y elevar tu experiencia frente al mar'
    },
    {
      icon: `${environment.s3BaseUrl}/icons/features/people.png`,
      title: '+1000 afiliados',
      description: 'Comprometidos a brindar un trato personalizado para cada huésped y accionistas'
    }
  ];

  getImageUrl(path: string): string {
    return `${this.s3BaseUrl}/${path}`;
  }
}
